import { useMutation } from '@tanstack/react-query';

import type { MutationConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

import type { AreasSchema } from '../schemas/areas';

type UseUpdateEstateAreas = {
  mutationConfig?: MutationConfig<typeof updateEstateAreas>;
};

export interface UpdateEstateAreas
  extends Partial<
      Record<
        keyof Omit<
          AreasSchema,
          | 'direction'
          | 'parkingSpacesType'
          | 'basementType'
          | 'accessibility'
          | 'basementCompartment'
          | 'atticCompartment'
          | 'hasElevator'
        >,
        number | null
      >
    >,
    Partial<
      Record<
        keyof Pick<AreasSchema, 'accessibility' | 'basementCompartment' | 'atticCompartment'>,
        boolean
      >
    >,
    Partial<
      Record<keyof Pick<AreasSchema, 'parkingSpacesType' | 'direction' | 'basementType'>, string>
    > {
  totalNumberOfRooms?: number | null;
  usableArea?: number | null;
  hasElevator?: number;
  id: string;
}

export const updateEstateAreas = ({ id, ...args }: UpdateEstateAreas) => {
  return extractData(api.estates({ id }).areas.put(args));
};

export const useUpdateEstateAreas = ({ mutationConfig }: UseUpdateEstateAreas) => {
  return useMutation({
    ...mutationConfig,
    mutationFn: updateEstateAreas,
  });
};
